import { Suspense, lazy, forwardRef } from 'react';

import { ScreenLoader } from '../ScreenLoader';

const LazyError = lazy(() => import('../Error'));

interface RemoteProps {
  hasError: boolean;
}

export const Remote = forwardRef(({ hasError }: RemoteProps, ref: React.ForwardedRef<HTMLDivElement>) => {
  if (hasError) {
    return (
      <Suspense fallback={<ScreenLoader />}>
        <LazyError />
      </Suspense>
    );
  };

  return <div ref={ref} />
});